<template>
  <div class="how-to-page">
    <HeadNav
      selected-language="en"
      page="how-to"
    />

    <main class="how-to-main">
      <nav class="breadcrumb" aria-label="Breadcrumb">
        <a href="/">Home</a>
        <span aria-hidden="true">/</span>
        <span aria-current="page">How-to</span>
      </nav>

      <header class="how-to-header">
        <h1>GB WhatsApp How-To Guides</h1>
      </header>

      <section class="guide-section" aria-label="GB WhatsApp how-to articles">
        <div class="article-grid">
          <a
            v-for="(article, index) in articles"
            :key="article.slug"
            class="article-card"
            :href="article.path"
          >
            <span class="article-number" aria-hidden="true">
              {{ String(index + 1).padStart(2, '0') }}
            </span>
            <h2>{{ article.h1 }}</h2>
            <p class="article-description">{{ article.description }}</p>
          </a>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import howToArticles from '@/constants/howToArticles';

export default {
  name: 'HowTo',
  components: {
    HeadNav,
  },
  data() {
    return {
      articles: howToArticles,
    };
  },
};
</script>

<style lang="scss" scoped>
.how-to-page {
  min-height: 100vh;
  background: #f5f8f7;
  color: #14213d;
}

.how-to-main {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
  padding: 24px 0 64px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 18px;
  color: #64748b;
  font-size: 13px;

  a {
    color: #0b6d47;
    font-weight: 600;
    text-decoration: none;
  }
}

.how-to-header {
  padding: 42px 38px;
  border: 1px solid #dcebe4;
  border-radius: 8px;
  background:
    linear-gradient(120deg, rgba(255, 255, 255, 0.96), rgba(237, 249, 243, 0.96)),
    #fff;
  box-shadow: 0 10px 28px rgba(23, 70, 52, 0.06);
}

.how-to-header h1 {
  max-width: 760px;
  margin: 0;
  color: #112a21;
  font-size: clamp(32px, 6vw, 52px);
  line-height: 1.12;
  letter-spacing: -0.02em;
}

.guide-section {
  margin-top: 26px;
}

.article-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.article-card {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  grid-template-rows: auto 1fr;
  gap: 8px 18px;
  min-height: 210px;
  padding: 24px;
  border: 1px solid #dfe9e4;
  border-radius: 8px;
  background: #fff;
  color: #14213d;
  text-decoration: none;
  box-shadow: 0 6px 20px rgba(28, 67, 53, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.article-card:hover,
.article-card:focus {
  border-color: #b8dcc9;
  box-shadow: 0 12px 28px rgba(28, 67, 53, 0.08);
  transform: translateY(-2px);
}

.article-number {
  display: grid;
  place-items: center;
  align-self: start;
  grid-row: 1 / span 2;
  width: 46px;
  height: 46px;
  border-radius: 7px;
  background: #eaf7f1;
  color: #0b6d47;
  font-size: 14px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.article-card h2 {
  margin: 0;
  color: #14213d;
  font-size: 19px;
  line-height: 1.38;
}

.article-description {
  align-self: start;
  margin: 2px 0 0;
  color: #5d6c66;
  font-size: 14px;
  line-height: 1.65;
}

@media (max-width: 800px) {
  .article-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .how-to-main {
    width: min(100% - 20px, 1120px);
    padding-top: 16px;
  }

  .how-to-header {
    padding: 30px 20px;
  }

  .how-to-header h1 {
    font-size: 34px;
  }

  .article-card {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 14px;
    min-height: 0;
    padding: 20px;
  }

  .article-number {
    grid-row: auto;
  }
}
</style>
